import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AiClassificationsTrayComponent } from './ai-classifications-tray.component';

@NgModule({
  declarations: [AiClassificationsTrayComponent],
  imports: [CommonModule, MatButtonModule, MatIconModule, MatMenuModule, MatTooltipModule],
  exports: [AiClassificationsTrayComponent],
})
export class AiClassificationsTrayModule {}
